<template>
  <section
    v-if="user !== null"
    id="chat"
    class="panel person"
    v-bind:class="{ hide: hidden }"
  >
    <div class="panel--header person--header">
      <h2 class="person--title person--title-panel">
        {{ $root.formatFullName(user.first_name, user.last_name) }}
        <small
          ><template
            v-if="user.usertype === this.$root.config.MENTOR_USER_TYPE"
            >{{ this.$root.config.mentor_label_singular }}</template
          ><template
            v-else-if="user.usertype === this.$root.config.MENTEE_USER_TYPE"
            >{{ this.$root.config.mentee_label_singular }}</template
          ><template v-else>{{
            this.$root.config.coord_label_singular
          }}</template></small
        >
      </h2>
      <a v-on:click="hide()" href="#" class="close panel--close">Close</a>
      <!-- <div class="buttongroup person--tabs">
        <a class="btn btn-active">Chat</a>
        <a href="#" class="btn">Peers</a>
        <a href="#" class="btn">Mentor Details</a>
      </div> -->
    </div>
    <div
      ref="chatBox"
      class="person--main chat"
    >
      <section 
        class="chat--day"
        v-for="(day, DayIndex) in messages"
        v-bind:key="day.date"
      >
        <h3>
          <time v-bind:datetime="day.sortKey">{{ day.date }}</time>
        </h3>
        <section
          v-for="(message, MessageIndex) in day.messages"
          v-bind:key="message.id"
          v-bind:data-mid="message.id"
          class="chat_msg"
        >
          <template v-if="message.content.indexOf($root.config.CHAT_SURVEY_TOKEN) !== 0">
            <header class="chat_msg--header">
              <h4 class="chat_msg--user">
                <!-- <img class="avatar user--avatar" src="img/lisa.jpg" width="30" height="30" alt=""> -->
                <span class="user--name">{{ getFullName(message.sender) }}</span>
              </h4>
              <time class="chat_msg--time">{{
                formatTime(message.date_created)
              }}</time>
              <div class="chat_msg--status field field-checkbox">
                <input 
                  type="checkbox" 
                  v-bind:id="message.id" 
                  v-bind:name="'message_' + DayIndex + '_' + MessageIndex"
                  class="field--checkbox" 
                  v-bind:checked="message.reviewed"
                  v-on:change="handleChange(message.id, $event.target.checked)">
                <label v-bind:for="message.id" class="field--label field--label-checkbox">Read</label>
              </div>
            </header>
            <div
              class="chat_msg--content"
              v-dompurify-html="message.content"
            ></div>
          </template>  
        </section>
      </section>
    </div>
    <footer class="person--footer">
      <form class="reply" v-on:submit.prevent="submit">
        <div
          v-if="hasChecked && this.messages.length === 0"
          class="reply--hello"
        >
          Say Hello to your new {{ $root.getDisplayUserType(user) }}!
        </div>
        <label v-if="showHint" for="chat_msg" class="reply--label"
          >Type a message</label
        >
        <textarea
          id="chat_msg"
          ref="input"
          v-model="message"
          v-bind:key="inputKey"
          name="chat_msg"
          class="reply--text"
          required=""
          cols="30"
          rows="1"
          maxlength="5000"
          v-on:keydown.enter.exact="handleSend"
          v-on:input="growInput"
        ></textarea>
        <button 
        type="submit" 
        class="reply--submit" 
        v-bind:disabled="sendButtonDisabled"
        v-on:click="handleSend">
          Send
        </button>
      </form>
    </footer>
  </section>
</template>
<script>
export default {
  name: "AdminChat",

  emits: ['readMessages', 'unreadMessages'],

  data() {
    return {
      hidden: true,
      user: null, // The other user - the user current admin user will be chatting with
      message: "", // Bind point for the text area
      inputKey: 0, // Used to force re-render of text area after message entry
      errorMessage: null, // For validation error messages
      messages: [], // All messages to and from self
      messageIndex: new Set(), // Used for fast de-duping of messages
      readBuffer: [], // Buffer for messages that need to be flagged as read
      observer: null, // InterSection observer for tracking which messages are visible
      lastChecked: null, // The last time we checked for messages
      //lastMessage: null, // Timestamp of the most recent message
      intervalId: null, // ID of setInterval for message polling
      hasChecked: false, // We only want to flag a new peer after we check the back end for messages, so track that here
      self: null, //the current admin user
    };
  },

  computed: {
    // Hide the "Type a message" hint when the user enters something in the message field
    showHint() {
      return this.message.length === 0;
    },

    // send button disabled if no text in the input
    sendButtonDisabled() {
      return this.message.length === 0;
    },
  },

  beforeUnmount() {
    // Remove polling when the user navigates away from the page
    this.unload();
  },

  methods: {
    show(user) {
      this.load(user);
      this.hidden = false;
    },
    hide() {
      this.hidden = true;
      this.unload();
    },

    load(user) {
      // if the user is clicking between different users there will already be an interval set up, 
      // so clear interval and empty the message containers first
      clearInterval(this.intervalId); 
      this.resetMessages();

      this.user = user;
      this.$root.callAuthenticatedEndpointNEW("getSelf", (details) => {
        this.self = details;
        this.getMessages();
        // Start polling the API for new messages
        this.intervalId = setInterval(
          this.intervalHandler,
          this.$root.config.MESSAGING_POLL_INTERVAL
        );
      });
    },
    unload() {
      this.user = null;
      clearInterval(this.intervalId);
      //this.flagMessagesAsRead();
      this.resetMessages();
    },
    resetMessages() {
      this.messages = [];
      this.messageIndex = new Set();
      this.readBuffer = [];
    },

    handleChange(messageId, checked) {
      console.log(messageId);
      console.log(checked);
      if (checked) {
        this.markMessageAsRead(messageId);
      } else {
        this.markMessageAsUnread(messageId);
      }

    },

    getFullName(id) {
      let person;
      if (id === this.user.id) {
        person = this.user;
      } else {
        return this.$root.config.coord_label_singular;
      }
      return this.$root.formatFullName(person.first_name, person.last_name);
    },

    getMessages() {
      this.setLastChecked();
      this.$root.api.getMessagesCoordinatorUser(
        this.user.id,
        this.$root.user.token,
        (messages) => {
          for (let message of messages?.results) {
            this.addMessage(message);
          }
          this.hasChecked = true;
          this.scrollChatBoxToBottom();
          
        }
      );
    },

    addMessage(message) {
      // Abort if we already have this message
      if (this.messageIndex.has(message.id)) {
        // 🔄 Update reviewed field in existing message
        for (let day of this.messages) {
          for (let m of day.messages) {
            if (m.id === message.id) {
              m.reviewed = message.reviewed; // update reviewed status
              return;
            }
          }
        }
      }
      this.messageIndex.add(message.id);
      // TODO: remove once we have intersection observer working
      // For now, add set all unread messages to be flagged as read
      if (!message.reviewed && message.sender === this.user.id) {
        this.readBuffer.push(message.id);
      }
      // API dates are in UTC, so we need to create a formatted date in user's local time zone
      let day = new Date(message.date_created);
      let fmt = new Intl.DateTimeFormat("en-US", {
        dateStyle: "medium",
      });
      let dayStr = fmt.format(day);
      let i = this.messages?.find((message) => {
        return message.date === dayStr;
      });

      // TODO: consider formatting timestring here
      // We have to do the message display formatting here due to the constraints of v-html
      message.content = message.content.replace(/\n/g, "<br>");
      // Create a new date is not already in messages; otherwise append to messages array of the date in question
      if (i === undefined) {
        // This ugly construction is the best way to get a local YYYY-MM-DD string
        // We can't use Date.toISOString() as it converts the date to UTC, which may change the day
        let sortString = this.$root.dateToYmd(day);
        this.messages.push({
          date: dayStr,
          sortKey: sortString,
          messages: [message],
        });
      } else {
        i.messages.push(message);
        // API sends messages in reverse cron order, so we need to re-sort to cron.
        // We can sort the ISO 8601 strings lexically
        i.messages.sort((a, b) => {
          if (b.date_created > a.date_created) {
            return -1;
          }
          if (a.date_created > b.date_created) {
            return 1;
          }
          return 0;
        });
        
      }
      // We also need to re-sort the top level of the messages array to put the dates cron order
       // The sortkey is set up for lexical sorting
      this.messages.sort((a, b) => {
        let sortA = a.sortKey;
        let sortB = b.sortKey;
        if (sortB > sortA) {
          return -1;
        }
        if (sortA > sortB) {
          return 1;
        }
        return 0;
      });
    },

    formatDate(dateString) {
      const dt = new Date(dateString);
      const fmt = new Intl.DateTimeFormat(this.$root.getLocale(), {
        dateStyle: "medium",
      });
      return fmt.format(dt);
    },

    formatTime(timeString) {
      const dt = new Date(timeString);
      const fmt = new Intl.DateTimeFormat(this.$root.getLocale(), {
        timeStyle: "short",
      });
      return fmt.format(dt);
    },

    setLastChecked() {
      this.lastChecked = new Date().toISOString();
    },

    growInput() {
      let input = document.querySelector("#chat_msg");
      input.style.height = input.scrollHeight + "px";
    },

    scrollChatBoxToBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.chatBox.scrollTop = 99999;
        }, 100);
      });
    },

    handleSend(event) {
      // Validation: do not post if the message is whitespace only
      let nonWhiteSpace = /\S/g;
      if (!nonWhiteSpace.test(this.message)) {
        event.preventDefault();
        this.message = "";
        this.errorMessage = this.$root.localize(
          "components.Messaging.errorEmptyMessage"
        );
        console.log(this.errorMessage);
        return false;
      }
      //reset errorMessage to default if we passed validation
      this.errorMessage = "";

      if (this.sendMessage(this.message)) {
        // Reset the message input to its default state
        this.message = "";
        // Changing the key the textarea is bound to forces it to re-render,
        // which resets it to its initial one-row height
        this.inputKey++;
        // Scroll chatbox down again and re-focus input
        this.scrollChatBoxToBottom();
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.input.focus();
          }, 100);
        });
      }
      // TODO: handle failure of message send to API
    },

    sendMessage(text) {
      // Send message to API
      this.$root.callAuthenticatedEndpointNEW(
        "sendMessageFromCoordinator",
        (response) => {
          // Return false if API call fails. Otherwise, add message locally using ID returned from the API
          if (!response) {
            return false;
          }
          this.addMessage(response);
          console.log(response);
        },
        this.user.id,
        text
      );

      // Return true if message post to API succeeds
      return true;
    },

    pollMessages() {
      const checkTime = this.lastChecked;
      console.log("Checking for messages since " + checkTime);
      this.setLastChecked();
      this.$root.api.getMessagesCoordinatorUser(
        this.user.id,
        this.$root.user.token,
        (messages) => {
          for (let message of messages.results) {
            this.addMessage(message);
          }
        },
        checkTime
      );
    },

    // TODO: rework once IntersectionObserver is working
    intervalHandler() {
      this.pollMessages();
    },

    // TODO: needs fixing
    // This method does NOT reset the user session
    flagMessagesAsRead() {
      //const messages = this.readBuffer;
      if (this.readBuffer.length > 0) {
        this.$root.api.flagMessagesAsRead(
          this.readBuffer,
          this.$root.user.token,
          (messages) => {
            console.log("Flagged messages as read: " + messages.length);
            // Tell container component to reduce unread message count
            this.$emit('readMessages', this.user.id, messages.length);
          }
        );
        this.readBuffer = [];
      }
    },

    markMessageAsRead(messageId) {
      this.$root.api.flagMessagesAsRead(
        [messageId],
        this.$root.user.token,
        (messages) => {
          console.log("Flagged messages as read: " + messages.length);
          // Tell container component to reduce unread message count
          this.$emit('readMessages', this.user.id, messages.length);
        }
      );
    },

    markMessageAsUnread(messageId) {
      this.$root.api.flagMessagesAsUnread(
        [messageId],
        this.$root.user.token,
        (messages) => {
          console.log("Flagged messages as unread: " + messages.length);
          // Tell container component to reduce unread message count
          this.$emit('unreadMessages', this.user.id, messages.length);
        }
      );
    },
  },
};
</script>
<style scoped>
.hide {
  display: none;
}
</style>
